import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { ApiOwnerBalance } from "@/generated/models/ApiOwnerBalance";
export function useIdentityBalance(t0) {
  const $ = _c(11);
  const {
    consolidationKey
  } = t0;
  let t1;
  let t2;
  if ($[0] !== consolidationKey) {
    t1 = ["identity-balance", consolidationKey];
    t2 = async () => await commonApiFetch({
      endpoint: `owners-balances/consolidation/${consolidationKey}`
    });
    $[0] = consolidationKey;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!consolidationKey;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data,
    isLoading,
    error
  } = useQuery(t4);
  let t5;
  if ($[7] !== data || $[8] !== error || $[9] !== isLoading) {
    t5 = {
      data,
      isLoading,
      error
    };
    $[7] = data;
    $[8] = error;
    $[9] = isLoading;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}